(function () {
  'use strict';

  function money(amount) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(amount / 100);
    } catch (e) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function rewriteFlavorLinks() {
    // Only runs on the storytelling template. Always adds #buy-box for smooth-scroll.
    // Carries view= and preview_theme_id= forward ONLY if present in the current URL
    // (i.e., during preview). In production (published theme + template assigned to both
    // products), neither param is added — flavor links stay clean.
    var isStorytelling = document.body.classList.contains('template-storytelling');
    if (!isStorytelling) return;

    var currentParams = new URLSearchParams(window.location.search);
    var viewParam = currentParams.get('view');
    var previewTheme = currentParams.get('preview_theme_id');

    var links = document.querySelectorAll('.collection-products-link');
    links.forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        if (viewParam && !url.searchParams.get('view')) {
          url.searchParams.set('view', viewParam);
        }
        if (previewTheme && !url.searchParams.get('preview_theme_id')) {
          url.searchParams.set('preview_theme_id', previewTheme);
        }
        url.hash = 'buy-box';
        a.href = url.pathname + url.search + url.hash;
      } catch (e) {}
    });
  }

  // On arrival, if hash is #buy-box, scroll smoothly after layout settles.
  function scrollToBuyBoxOnArrival() {
    if (window.location.hash !== '#buy-box') return;
    var target = document.getElementById('buy-box');
    if (!target) return;
    // Give Recharge / lazy images a beat, then scroll.
    setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 250);
  }

  function init() {
    rewriteFlavorLinks();
    scrollToBuyBoxOnArrival();

    var bar = document.querySelector('.vital-pals-sticky-buy-bar');
    if (!bar) return;

    var anchorSel = bar.getAttribute('data-anchor') || '#buy-box';
    var threshold = parseInt(bar.getAttribute('data-hide-threshold'), 10) || 600;

    var anchorEl = null;
    function resolveAnchor() {
      if (!anchorEl) anchorEl = document.querySelector(anchorSel);
      return anchorEl;
    }

    var priceNowEl = bar.querySelector('.vital-pals-sticky-buy-bar__price-now');
    var priceOldEl = bar.querySelector('.vital-pals-sticky-buy-bar__price-old');
    var metaEl = bar.querySelector('[data-sticky-meta]');

    function setVisible(visible) {
      if (visible) {
        bar.setAttribute('data-visible', 'true');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('vital-pals-sticky-active');
      } else {
        bar.setAttribute('data-visible', 'false');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('vital-pals-sticky-active');
      }
    }

    // Hide bar when the real buy box is already visible in viewport
    var buyBoxInView = false;
    var anchor = resolveAnchor();
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        buyBoxInView = entries[0].isIntersecting;
        onScroll();
      }, { threshold: 0.2 });
      io.observe(anchor);
    }

    function onScroll() {
      var scrolled = window.scrollY || document.documentElement.scrollTop || 0;
      var shouldShow = scrolled > threshold && !buyBoxInView;
      setVisible(shouldShow);
    }

    // CTA smooth scroll to buy box
    var cta = bar.querySelector('[data-sticky-cta]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        var target = resolveAnchor();
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var form = target.querySelector ? target.querySelector('form[action*="/cart/add"]') : null;
          if (form) {
            setTimeout(function () {
              var btn = form.querySelector('button[type="submit"], button[name="add"]');
              if (btn) btn.focus();
            }, 500);
          }
        }
      });
    }

    // Sync sticky bar price + meta with the main product form
    function syncFromMainForm() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      // Selling plan (subscription) selection
      var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      var planProp = form.querySelector('input[name="properties[_selling_plan]"]');
      var isSubscribe = false;
      if (sellingPlanInput && sellingPlanInput.value) isSubscribe = true;
      if (planProp && planProp.value && planProp.value !== 'one-time') isSubscribe = true;

      // Also detect from selected radio in UI (Recharge widget sometimes uses radios)
      var checkedRadio = form.querySelector('input[type="radio"]:checked, [aria-checked="true"][role="radio"]');
      if (checkedRadio) {
        var labelText = (checkedRadio.closest('label') || checkedRadio.parentNode || {}).textContent || '';
        if (/subscribe/i.test(labelText)) isSubscribe = true;
        if (/one[-\s]?time/i.test(labelText)) isSubscribe = false;
      }

      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var metaText = isSubscribe ? 'Subscribe & Save · ' + qty + ' pack' + (qty > 1 ? 's' : '') + ' / month'
                                  : 'One-time purchase · ' + qty + ' pack' + (qty > 1 ? 's' : '');
      if (metaEl) metaEl.textContent = metaText;

      // Price sync: look for visible price in the product form area
      var priceEl = document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular');
      if (priceEl && priceNowEl) {
        var txt = priceEl.textContent && priceEl.textContent.trim();
        if (txt) priceNowEl.textContent = txt;
      }
      var comparePriceEl = document.querySelector('.price__compare .price-item--regular, .price-item--compare');
      if (priceOldEl) {
        if (comparePriceEl && comparePriceEl.textContent.trim()) {
          priceOldEl.textContent = comparePriceEl.textContent.trim();
          priceOldEl.style.display = '';
        } else {
          priceOldEl.style.display = 'none';
        }
      }
    }

    // Throttled scroll listener
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { onScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    // Observe form mutations (Recharge re-renders when user toggles plan)
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var mo = new MutationObserver(function () { syncFromMainForm(); });
      mo.observe(form, { childList: true, subtree: true, attributes: true, characterData: true });
      form.addEventListener('change', syncFromMainForm, true);
      form.addEventListener('click', function () { setTimeout(syncFromMainForm, 50); }, true);
    }

    // Initial
    onScroll();
    syncFromMainForm();
    setTimeout(syncFromMainForm, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
